// extracted by mini-css-extract-plugin
module.exports = {"commissionTable":"_13npYSSW8VtXvOhzrGSxCZ","footer":"_2eemmxjFhmgvta3yYW91P1"};